module.exports = __webpack_public_path__ + "img/guide_5_1.900fe62a.svg";